module.exports = __webpack_public_path__ + "static/media/samsung-awesome-is-for-everyone-2021.d576a047.jpg";